module.exports = "/foodslaboEf/img/Thanks/thanks_sparkles.png";